var activitiesService = function () {
  this.getActivitiesByDemand = function (projectUid, demandId) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/activities/project/${projectUid}/demand/${demandId}`, {
        method: "GET",
        headers: {
          // "session_token": AuthenticationService.getUser() && AuthenticationService.getUser().session_token,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.getActivitiesByObject = function (projectUid, objectId) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/activities/project/${projectUid}/object/${objectId}`, {
        method: "GET",
        headers: {
          // "session_token": AuthenticationService.getUser() && AuthenticationService.getUser().session_token,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.post = function (model) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/activities`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "title": model.title,
          "description": model.description,
          "estimate": model.estimate,
          "start_date": model.start_date,
          "end_date": model.end_date,
          "object_id": model.object_id,
          "composition_uid": model.composition_uid,
          "project_uid": model.project_uid,
          "user_uid": model.user_uid,
          "status": model.status,
          "demand_id": model.demand_id
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.put = function (id, model) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demand/` + id, {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "title": model.title,
          "goal": model.goal
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.delete = function (id) {
    return new Promise(function (resolve, reject) {
      fetch(`http://localhost:3000/rdpmanager/demand/` + id, {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  return this;
}

var ActivitiesService = new activitiesService();

export {
  ActivitiesService
};